import { hiddenInBranch } from './catalog-filters';
import type { ICatalogSection } from './catalog-view';

/**
 * The categories products can move to (plan §5.9, «Mover a otra
 * categoría»): the current menu's categories in order, without the one
 * they are in, each with what would limit the moved products.
 */

/** Why products in this category are not simply orderable, by priority. */
export type TMoveTargetLimit =
  | 'hidden'
  | 'hiddenHere'
  | 'posOnly'
  | 'scheduled';

export interface IMoveTarget {
  id: number;
  name: string;
  count: number;
  limit: TMoveTargetLimit | null;
  /** The category's schedule in words («lun a vie · 12:00 a 16:00»), if any. */
  schedule: string | null;
}

export function moveTargetLimit(
  section: ICatalogSection,
  branchId: number | null
): TMoveTargetLimit | null {
  const { category } = section;
  if (!category.visible) return 'hidden';
  if (hiddenInBranch(category, branchId)) return 'hiddenHere';
  if (category.posOnly) return 'posOnly';
  if (category.hourRanges?.length) return 'scheduled';
  return null;
}

/** `scheduleText` words a category's schedule (null without one). */
export function moveTargets(
  sections: readonly ICatalogSection[],
  excludeCategoryId: number | null,
  branchId: number | null,
  scheduleText: (section: ICatalogSection) => string | null = () => null
): IMoveTarget[] {
  return sections
    .filter((section) => section.category.id !== excludeCategoryId)
    .map((section) => ({
      id: section.category.id,
      name: section.category.name,
      count: section.items.length,
      limit: moveTargetLimit(section, branchId),
      schedule: scheduleText(section),
    }));
}
